export const loadingStyles = `
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  max-width: none;
  z-index: 102;
  background: #fff;
`;
